import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class AssetLocation extends Enum {
  static SAFE = {
    key: 'safe',
    get value() {
      return Lang.t('asset.safe');
    }
  };

  static DEPOSIT_BOX = {
    key: 'deposit_box',
    get value() {
      return Lang.t('asset.safety-deposit-box');
    }
  };

  static PRIMARY_RESIDENCE = {
    key: 'primary_residence',
    get value() {
      return Lang.t('asset.74ec2d49-e690-4f1e-8f73-e6c09380bb23');
    }
  };

  static OTHER_REAL_ESTATE = {
    key: 'other_real_estate',
    get value() {
      return Lang.t('asset.other-estate-used');
    }
  };

  static STORAGE_FACILITY = {
    key: 'storage_facility',
    get value() {
      return Lang.t('asset.storage-facility');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
